<template>
  <div class="contain">
    <div class="topTitle flex">
      <span class="preview"></span>
      <el-select
        @change="MerchSelete"
        v-model="region"
        placeholder="请选择商户"
        style="width: 200px"
      >
        <el-option
          v-for="(item, index) in seleteAppList"
          :key="index"
          :label="item.nickName"
          :value="index"
        ></el-option>
      </el-select>
    </div>
    <div class="conTips">
      <div class="introduce flex">
        <span
          >留存分析可分别查看新增、活跃用户的留存情况。用户在某段时间内开始使用小程序，经过一段时间后，仍然继续使用该小程序的用户，被认作是留存用户。这部分用户占当时用户的比例即是留存率，留存率是判断拉新效果和用户粘性最直接的指标之一。</span
        >
      </div>
      <div class="searchTime">
        <div class="seleSearchTime flex">
          <div class="flex">
            <div
              class="pressActive flex flex-center item-center"
              :class="[item.checked ? 'activers' : '']"
              @click="seletesTimes(index)"
              v-for="(item, index) in seleButton"
              :key="index"
            >
              <span
                class="copywriting"
                :class="[item.checked ? 'active' : '']"
                >{{ item.name }}</span
              >
            </div>
          </div>
          <el-date-picker
            v-model="value1"
            @change="change"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>
        <div class="tabFrom">
          <el-table
            stripe
            border
            ref="multipleTable"
            :data="tableData"
            style="width: 100%"
            id="table"
            size="small"
          >
            <el-table-column
              prop="ref_date"
              label="时间"
              sortable
              width="180"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="num0"
              label="新增用户"
              width="180"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="num1"
              label="1天后"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="num2"
              label="2天后"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="num3"
              label="3天后"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="num4"
              label="4天后"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="num5"
              label="5天后"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="num6"
              label="6天后"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="num7"
              label="7天后"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="num8"
              label="14天后"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="num9"
              label="30天后"
              align="center"
            ></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value1: "",
      region: "",
      tableData: [],
      yesterday: "", // 昨天
      week: "",
      initiali: {},
      seleteAppList: [],
      isquery: true,
      seleButton: [
        {
          name: "新增用户",
          checked: true
        },
        {
          name: "活跃",
          checked: false
        }
      ]
    };
  },
  created() {
    let curDate = new Date();
    var nowDate = curDate.getTime();
    var preDate = new Date(curDate.getTime() - 24 * 60 * 60 * 1000); //前一天
    var week = new Date(curDate.getTime() - 24 * 60 * 60 * 1000 * 7); // 过去7天
    this.yesterday = this.formatDateTime(preDate);
    this.week = this.formatDateTime(week);
    this.getSeleteWechat();
  },
  methods: {
    async query_list() {
      const { result } = await this.$store.dispatch("queryAllRetain", {
        busType: this.initiali.miniProgramType,
        queryEndDate: this.yesterday,
        queryStartDate: this.week,
        storeCode: this.initiali.storeCode
      });
      if (this.isquery) {
        console.log(result);
        // 查询新增用户
        result.forEach((item, index) => {
          item.visit_uv_new.forEach((list, listIndex) => {
            item["num" + listIndex] = list.value;
          });
        });
      } else {
        // 查询活跃客户
        result.forEach((item, index) => {
          item.visit_uv.forEach((list, listIndex) => {
            item["num" + listIndex] = list.value;
          });
        });
      }

      this.tableData = result;
      console.log(this.tableData);
    },
    async getSeleteWechat() {
      const { result } = await this.$store.dispatch("queryWechatSelete", {});
      this.seleteAppList = result;
      this.initiali = result[0];
      this.region = this.initiali.nickName;
      this.query_list();
    },
    seletesTimes(index) {
      this.seleButton.forEach(item => {
        item.checked = false;
      });
      this.seleButton[index].checked = !this.seleButton[index].checked;
      if (index === 0) {
        // 查询新增用户
        this.isquery = true;
        this.query_list();
      } else if (index === 1) {
        this.isquery = false;
        this.query_list();
      }
    },
    change(e) {},
    MerchSelete(e) {
      let index = e;
      this.initiali = this.seleteAppList[index];
      this.query_list();
    },
    formatDateTime(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var minute = date.getMinutes();
      minute = minute < 10 ? "0" + minute : minute;
      var second = date.getSeconds();
      second = second < 10 ? "0" + second : second;
      return y + "-" + m + "-" + d;
    }
  }
};
</script>

<style lang="scss" scoped>
.contain {
  // flex-direction: column;
  .topTitle {
    background: #fff;
    margin-bottom: 10px;
    padding: 20px;
    align-items: center;
    justify-content: space-between;
    // align-items: center;
    // border-bottom: 1px solid #e5e9f2;
    .preview {
      color: #222222;
      font-weight: 500;
      font-size: 26;
    }
  }
  .conTips {
    padding: 20px 20px;
    background: #ffffff;
  }

  .introduce {
    padding: 20px 0;
    padding: 16px;
    flex-direction: column;
    background: #fff8f1;
    border: 1px solid #ff7f10;
    span {
      color: #ff7f10;
      font-size: 14px;
    }
  }
  .searchTime {
    width: 100%;
    margin-top: 20px;
    .seleSearchTime {
      justify-content: space-between;
      .pressActive {
        width: 90px;
        height: 40px;
        background: #ffffff;
        border: 1px solid #dcdfe6;
        cursor: pointer;
        .copywriting {
          color: #000;
          font-size: 14px;
          &.active {
            color: #ffffff;
          }
        }
        &.activers {
          background: #e50065;
        }
      }
    }
  }
  .tabFrom {
    margin-top: 20px;
  }
}
</style>
